<template>
    <ApprovedPayments></ApprovedPayments>
</template>
<script>
    import ApprovedPayments from '@/components/ApprovedPaymentLiquidations.vue'
    export default {
        name: 'approved-liquidations',
        components: {
            ApprovedPayments
        }
    }
</script>